import React from "react";
import { Row, Col, Form, Button, Image } from "react-bootstrap";
import firebase from "../Utils/Firebase";

// Logo image file path
import Logo from "../assets/img/logo.png";
import User from "../model/User";

class Login extends React.Component {
  onLoginHandler = () => {
    let email = document.getElementById("email").value;
    let password = document.getElementById("password").value;
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((result) => {
        console.log(result);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  componentDidMount() {
    this.logout();
  }

  logout = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {});
  };

  render() {
    return (
      <div className="auth-main-content auth-bg-image">
        <div className="d-table">
          <div className="d-tablecell">
            <div className="auth-box">
              <Row>
                <Col md={6}>
                  <div className="form-left-content">
                    <div className="auth-logo">
                      <Image src={Logo} alt="Logo" />
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form-content">
                    <h1 className="heading">Log In</h1>

                    <Form onSubmit={this.onLoginHandler}>
                      <Form.Group>
                        <Form.Label>Email address</Form.Label>
                        <Form.Control id="email" type="email" />
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>Password</Form.Label>
                        <Form.Control id="password" type="password" />
                      </Form.Group>

                      <div className="text-center">
                        <Button
                          variant="primary"
                          onClick={() => this.onLoginHandler()}
                        >
                          Log In
                        </Button>
                      </div>
                    </Form>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
